<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
  <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>
<app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
</app-return-methods>
<div class="contentBox">
  <div class="center col-3">
    <div class="info-logo-container">
      <img src="{{ info.logo }}" class="payment_method_no_interactive __method_brands" alt="Logo PSE" />
    </div>
  </div>
  <div class="col-7">
    <div class="methodInfo">
      <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
      </app-return-methods>

      <ng-container *ngIf="isBancolombiaButton() else defaultWalletsTitle">
        <h1>{{ 'payMethods-Bancolombia' | translation | async }}</h1>
      </ng-container>

      <ng-template #defaultWalletsTitle>
        <h1>{{ 'payMethods-Wallet' | translation | async }}</h1>
      </ng-template>

      <div id="__pse_form" class="methodForm">
        <form [formGroup]="form">
          <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('name') }">
            <mat-label>{{ 'forms-Name-Input' | translation | async }}</mat-label>
            <input type="text" name="name" matInput formControlName="name"
              placeholder="{{ 'forms-Name-Input' | translation | async }}" [readonly]="isControlReadOnly('name')" />
          </mat-form-field>
          <ng-container *ngFor="let validation of errorsMessagesPSE.name">
            <div class="error-message"
              *ngIf="form.get('name').hasError(validation.type) && (form.get('name').dirty || form.get('name').touched)">
              {{ validation.message }}
            </div>
          </ng-container>
          <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('typeDI') }">
            <mat-label>{{ 'forms-TypeDoc-Input' | translation | async }}</mat-label>
            <mat-select placeholder="{{ 'forms-TypeDoc-Input' | translation | async }}" formControlName="typeDI">
              <mat-option [value]="document.VALUE" *ngFor="let document of listOfDocuments"
                [readonly]="isControlReadOnly('typeDI')">{{
                document.TEXT }}</mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngFor="let validation of errorsMessagesPSE.typeDI">
            <div class="error-message"
              *ngIf="form.get('typeDI').hasError(validation.type) && (form.get('typeDI').dirty || form.get('typeDI').touched)">
              {{ validation.message }}
            </div>
          </ng-container>
          <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('di') }">
            <mat-label>{{ 'forms-NumDoc-Input' | translation | async }}</mat-label>
            <input autocomplete="off" type="text" matInput name="di"
              placeholder="{{ 'forms-NumDoc-Input' | translation | async }}" required (focusout)="validDI()"
              formControlName="di" [readonly]="isControlReadOnly('di')" />
          </mat-form-field>
          <ng-container *ngFor="let validation of errorsMessagesPSE.di">
            <div class="error-message"
              *ngIf="form.get('di').hasError(validation.type) && (form.get('di').dirty || form.get('di').touched)">
              {{ validation.message }}
            </div>
          </ng-container>
          <div class="error-message" *ngIf="validate_document">
            {{ 'forms-document-invalid' | translation | async }}
          </div>

          <mat-form-field *ngIf="by_pseavanza" appearance="outline"
            [ngClass]=" { disabledInput: isControlReadOnly('cellPhone') }">
            <mat-label> {{'forms-NumCel-Input' | translation | async}} </mat-label>
            <input autocomplete="off" type="text" matInput placeholder="Móvil" required name="cellPhone"
              formControlName="cellPhone" [readonly]="isControlReadOnly('cellPhone')" />
            <fa-icon matSuffix icon="mobile-alt"></fa-icon>
          </mat-form-field>
          <ng-container *ngFor="let validation of errorsMessages.cellPhone">
            <div class="error-message"
              *ngIf="form.get('cellPhone').hasError(validation.type) && (form.get('cellPhone').dirty || form.get('cellPhone').touched)">
              {{ validation.message }}
            </div>
          </ng-container>
          <mat-form-field *ngIf="by_pseavanza" appearance="outline"
            [ngClass]=" { disabledInput: isControlReadOnly('email') }">
            <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
            <input autocomplete="off" type="text" matInput placeholder="Email" required name="email"
              formControlName="email" [readonly]="isControlReadOnly('email')" />
            <fa-icon matSuffix icon="envelope"></fa-icon>
          </mat-form-field>
          <ng-container *ngFor="let validation of errorsMessages.email">
            <div class="error-message"
              *ngIf="form.get('email').hasError(validation.type) && (form.get('email').dirty || form.get('email').touched)">
              {{ validation.message }}
            </div>
          </ng-container>

          <mat-form-field *ngIf="by_pseavanza" appearance="outline"
            [ngClass]=" { disabledInput: isControlReadOnly('address') }">
            <mat-label>{{ 'forms-address-input' | translation | async }}</mat-label>
            <input autocomplete="off" type="text" matInput placeholder="Dirección" required name="address"
              formControlName="address" [readonly]="isControlReadOnly('address')" />
            <fa-icon matSuffix icon="home"></fa-icon>
          </mat-form-field>
          <ng-container *ngFor="let validation of errorsMessagesPSE.address">
            <div class="error-message"
              *ngIf="form.get('address').hasError(validation.type) && (form.get('address').dirty || form.get('address').touched)">
              {{ validation.message }}
            </div>
          </ng-container>

          <mat-form-field appearance="outline">
            <mat-label>{{ 'pse-TypeClient' | translation | async }}</mat-label>
            <mat-select placeholder="{{ 'pse-TypeClient' | translation | async }}" formControlName="personType"
              required>
              <mat-option [value]="type.value" *ngFor="let type of typeClients">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngFor="let validation of errorsMessagesPSE.personType">
            <div class="error-message"
              *ngIf="form.get('personType').hasError(validation.type) && (form.get('personType').dirty || form.get('personType').touched)">
              {{ validation.message }}
            </div>
          </ng-container>
          <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
        </form>
      </div>
    </div>
    <app-buttons-bar [valid]="completedForms()" [template]="template" (PAY)="validData()"></app-buttons-bar>
  </div>
</div>
